<template>
  <div class="payment-container">
    <div class="card">
      <h2>Receive Loan Payment</h2>

      <form @submit.prevent="receivePayments">
        
        <div class="form-group">
          <label>Customer Name</label>
          <input v-model="form.FirstName" type="text" required />
        </div>

        <div class="form-group">
          <label>Phone (MSISDN)</label>
          <input v-model="form.MSISDN" type="text" required />
        </div>
          <div class="form-group">
          <label>Transacton ID</label>
          <input v-model="form.TransID" type="text" required />
        </div>

            <div class="form-group">
          <label>Trans time</label>
          <input v-model="form.TransTime" type="text" required />
        </div>

        <div class="form-group">
          <label>Amount</label>
          <input v-model="form.TransAmount" type="number" required />
        </div>

        <div class="form-group">
          <label>ID Number (BillRefNumber)</label>
          <input v-model="form.BillRefNumber" type="text" required />
        </div>

        <button type="submit" :disabled="loading">
          {{ loading ? "Processing..." : "Submit Payment" }}
        </button>

      </form>

      <p v-if="message" :class="success ? 'success' : 'error'">
        {{ message }}
      </p>

    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {

  data() {
    return {
      loading: false,
      message: "",
      success: false,

      form: {
        FirstName: "",
        MSISDN: "",
        TransAmount: "",
        BillRefNumber: "",
         TransID: "",
          TransTime: ""
      },
    };
  },

  methods: {
 



        async receivePayments(){
      const response = await axios.post("https://api.roberms.com/raisetrack/receive/loan/payment", this.form)
      console.log(response)
        // axios.post("http://localhost:5000/user/registration", this.formData)
        // .then(response=>console.log(response))
        // .catch(error=>console.log(error))
        this.$router.replace('/loan/payments');
        console.log(this.formData)

    

    },

    
  },
};
</script>

<style scoped>
.payment-container {
  display: flex;
  justify-content: center;
  padding: 40px;
  background: #f5f7fb;
}

.card {
  width: 400px;
  padding: 25px;
  border-radius: 12px;
  background: white;
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
}

h2 {
  text-align: center;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  font-weight: 600;
  display: block;
  margin-bottom: 5px;
}

input {
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ddd;
}

button {
  width: 100%;
  padding: 12px;
  border: none;
  background: #4CAF50;
  color: white;
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
}

button:disabled {
  background: #aaa;
}

.success {
  color: green;
  margin-top: 15px;
  text-align: center;
}

.error {
  color: red;
  margin-top: 15px;
  text-align: center;
}
</style>